import { Navigate, useParams } from "../../../../router-utils"

export default function AutomationItemPage() {
	const { automationId } = useParams("/automations/:automationId")

	if (!automationId) {
		return null
	}

	return (
		<Navigate
			to="/automations/:automationId/runs"
			params={{ automationId }}
			replace
		/>
	)
}
